// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1RCCj","colBig":"styles_colBig__3V5Ua","colSmall":"styles_colSmall__3XkAF"};